//
// locale_hu.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/brighteon/locales/hu.json';
import localeData from "react-intl/locale-data/hu.js";
import { setLocale } from '../../app/javascript/brighteon/locales';
setLocale({messages, localeData});
